export default __webpack_public_path__ + "static/media/logo-new-White-crop-Marina.57daa6a6.png";